import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import classNames from 'classnames';
import Measure from 'react-measure';
import styles from './Slider.module.less';

export default class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: -1,
      height: -1,
      active: 0,
      canUseWheel: true,
    };
  }
  // componentDidMount = () => {
  //   window.addEventListener('scroll', this.handleScroll);
  // };

  // componentWillUnmount = () => {
  //   window.removeEventListener('scroll', this.handleScroll);
  // };
  // handleScroll = (event) => {
  //   console.log(event.srcElement.body.scrollTop);
  // }
  wheel = (e) => {
    this.setState({
      canUseWheel: false,
    })
    setTimeout(() => {
      this.setState({
        canUseWheel: true,
      });
    }, 2000)
    if (e.deltaY > 0 && this.state.active !== this.state.childrens.length - 1) {
      this.nextSlide();
    } else if (e.deltaY < 0 && this.state.active !== 0) {
      this.previousSlide();
    }
  }
  componentWillMount = () => {
    this.setState({
      active: this.props.active,
      transition: false,
    });
    const childrens = this.props.children.filter((element) => {
      return element !== false;
    });
    childrens.forEach((element) => {
      if (Array.isArray(element)) {
        const index = childrens.indexOf(element);
        childrens.splice(index, 1);
        element.forEach((element2) => {
          childrens.push(element2);
        })
      }
    });
    this.setState({
      childrens: childrens,
    })
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.active) {
      this.setState({
        active: nextProps.active,
        transition: false,
      });
    } else {
      this.setState({
        active: 0,
        transition: true,
      });
    }
    const childrens = nextProps.children.filter((element) => {
      return element !== false;
    });
    childrens.forEach((element) => {
      if (Array.isArray(element)) {
        const index = childrens.indexOf(element);
        childrens.splice(index, 1);
        element.forEach((element2) => {
          childrens.push(element2);
        })
      }
    });
    this.setState({
      childrens: childrens,
    })
  }
  // shouldComponentUpdate = (nextProps, nextState) => {
  //   // return !(this.props === nextProps) && JSON.stringify(this.state) === JSON.stringify(nextState));
  //   console.log('nextState: ', nextState);
  //   console.log('this.state: ', this.state);
  //   console.log('nextProps: ', nextProps);
  //   console.log('this.props: ', this.props);
  //   // let test = (this.props == nextProps && this.state.active != nextState.active);
  //   if (this.props == nextProps && this.state.active != nextState.active) {
  //     console.log('nextState.active: ', nextState.active);
  //     console.log('this.state.active: ', this.state.active);
  //     return false;
  //   }
  //   return true;
  // }
  getWidth = (contentRect) => {
    // console.log(this.state.childrens.length)
    if (this.props.vertical) {
      this.setState({
        width: contentRect.bounds.width,
        containerWidth: (contentRect.bounds.width * this.state.childrens.length),
        height: contentRect.bounds.height,
        containerHeight: (contentRect.bounds.height * this.state.childrens.length),
      });
    } else {
      this.setState({
        width: contentRect.bounds.width,
        containerWidth: (contentRect.bounds.width * this.state.childrens.length),
      });
    }
  }
  previousSlide = () => {
    this.setState({
      transition: true,
    });
    if (this.state.active === 0) {
      this.setState({
        active: this.state.childrens.length - 1,
      });
    } else {
      this.setState({
        active: this.state.active - 1,
      });
    }
  }

  nextSlide = () => {
    this.setState({
      transition: true,
    });
    if (this.state.active === this.state.childrens.length - 1) {
      this.setState({
        active: 0,
      });
    } else {
      this.setState({
        active: this.state.active + 1,
      });
    }
  }

  calculateWidth = () => {
    return (this.state.active * -this.state.width);
  }
  calculateHeight = () => {
    return (this.state.active * -this.state.height);
  }

  handleClick = (index) => {
    this.setState({
      active: index,
    });
  }

  render() {
    console.log('render');
    return (
      <Measure
        bounds
        onResize={(contentRect) => {
          this.getWidth(contentRect);
        }}
      >
        {({ measureRef }) => (
          <div className={classNames(styles.superContainer, { [styles.superContainerVertical]: this.props.vertical }, { [styles.superContainerResponsive]: !this.props.isResponsive })} onWheel={this.state.canUseWheel && this.props.useWheel ? (e) => this.wheel(e) : null}>
            <div onClick={this.previousSlide} role="button" tabIndex={0} className={classNames(styles.btnPrev, styles.btnActive, { [styles.btnNotActive]: this.state.active === 0 })} />
            <div className={styles.sliderContainer} ref={measureRef}>
              <div className={styles.slider} style={{ transitionDuration: this.state.transition ? '1s' : '0s', width: this.props.vertical ? '100%' : this.state.containerWidth, height: this.props.vertical ? this.state.containerHeight : '100%', transform: this.props.vertical ? `translate3d(0px, ${this.calculateHeight()}px, 0px)` : `translate3d(${this.calculateWidth()}px, 0px, 0px)` }} >
                {this.state.childrens.map((element, index) => (
                  <div className={styles.element} style={{ width: this.state.width, height: this.state.height }}>
                    {element}
                  </div>
                ))}
              </div>
            </div>
            {/* <ul className={styles.list}>
              {this.state.childrens.map((element, index) => (
                <li>
                  <button className={classNames(styles.listElement, { [styles.active]: this.state.active === index })} onClick={() => this.handleClick(index)}>{index}</button>
                </li>
              ))}
            </ul> */}
            <div onClick={this.nextSlide} role="button" tabIndex={0} className={classNames(styles.btnNext, styles.btnActive, { [styles.btnNotActive]: this.state.active === this.state.childrens.length - 1 })} />
          </div>
        )
        }
      </Measure>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider/Slider.jsx